const initialState = {
  offers: null,
  liveBtcPrice: 0,
  cachedBtcPrice: 0,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_TYPE_OFFERS': {
      return {
        ...state,
        offers: payload.offers,
        liveBtcPrice: payload.liveBtcPrice,
        cachedBtcPrice: payload.cachedBtcPrice,
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/OfferDetails/OfferDetails.reducer.js